export default "__VITE_ASSET__NffbUC9r__"